var swiper = new Swiper(".banner-swiper", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  speed: 900,
  parallax: true,
  pagination: {
    el: ".banner-pagination",
    clickable: true,
  },
});

const tabsCell = document.querySelectorAll(".eco-tabs-sec");
const individualCell = document.querySelectorAll(".eco-tab");
tabsCell.forEach((section) => {
  individualCell.forEach((tabSec) => {
    var swiper = new Swiper(tabSec.querySelector(".eco-tabs-Swiper"), {
      slidesPerView: 4,
      spaceBetween: 30,
      loop: false,
      navigation: {
        nextEl: tabSec.querySelector(".eco-tabs-next"),
        prevEl: tabSec.querySelector(".eco-tabs-prev"),
      },
      breakpoints: {
        100: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        650: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });

  const tabsNav = section.querySelectorAll(".eco-tabs-nav ul li");
  const tabsContent = section.querySelectorAll(".eco-tabs-wrap .eco-tab");

  tabsNav.forEach((items, ind) => {
    items.addEventListener("click", () => {
      tabsNav.forEach((remove) => {
        remove.classList.remove("active");
      });

      items.classList.add("active");

      tabsContent.forEach((content) => {
        content.classList.remove("active");
      });

      tabsContent[ind].classList.add("active");
    });
  });
});








var swiper = new Swiper(".revSwiper", {
  direction: "horizontal", 
  slidesPerView: "auto",
  spaceBetween: 10,
  loop: true,
  speed: 800,
  mousewheelControl: true,
  watchSlidesProgress: true,
  mousewheel: {
    releaseOnEdges: true,
  },
  navigation: {
    nextEl: ".rev-button-next",
    prevEl: ".rev-button-prev",
  },
  breakpoints: {
    768: {
      direction: "vertical", // Default direction
    },
  },
});
